<vectronic-filter-header
  (titleClicked)="toggled.emit()"
  [title]="title()"
  (enabledFilterToggle)="toggled.emit()"
  [isFilterEnabled]="expanded()"
  [disabled]="disabled()"
></vectronic-filter-header>
<div class="filter-body" [hidden]="!expanded()">
  <vectronic-chips-autocomplete
    [selectedItems]="selectedItems()"
    [items]="availableFilterItems$ | async"
    [isDisabled]="disabled()"
    (selectItem)="onSelectFilterItem($event)"
    (deleteItem)="onDeleteFilterItem($event)"
    [enableAdd]="false"
    [enableConfirmationOnRemove]="false"
    (textChange)="filterTextChanged($event)"
  ></vectronic-chips-autocomplete>
</div>
